<script lang="ts" setup>


interface Prop {
  preset?: keyof typeof presets
}

const props = defineProps<Prop>()

const presets = {
  black_1: {
    class: ' bg-black text-white px-6 py-3 rounded-none justify-between',
    color: 'black'
  }
}

const preset = computed(() => presets[props.preset!] ?? {})

const mergeClass = (a, b) => {
  const classNames = [a.class, b.class].filter(v => v)
  return { ...a, ...b, class: classNames }
}

</script>

<template>
  <UButton loading-auto v-bind="mergeClass(preset, $attrs)">
    <slot></slot>
  </UButton>
</template>

<style lang="scss" scoped></style>
